import { createActionTypes } from "@src/utility"

export const JOB_TEMPLETE_TYPES = createActionTypes("JOB_TEMPLETE", [
  "GET_ALL_JOB_TEMPLETES_REQUEST",
  "GET_ALL_JOB_TEMPLETES_SUCCESS",
  "GET_ALL_JOB_TEMPLETES_FAIL",
  "GET_SPECIFIC_JOB_TEMPLETE_REQUEST",
  "GET_SPECIFIC_JOB_TEMPLETE_SUCCESS",
  "GET_SPECIFIC_JOB_TEMPLETE_FAIL",
  "CREATE_JOB_TEMPLETE_REQUEST",
  "CREATE_JOB_TEMPLETE_SUCCESS",
  "CREATE_JOB_TEMPLETE_FAIL",
  "RESET_CREATE_TEMPLATE",
  "UPDATE_JOB_TEMPLETE_REQUEST",
  "UPDATE_JOB_TEMPLETE_SUCCESS",
  "UPDATE_JOB_TEMPLETE_FAIL",
  "DELETE_JOB_TEMPLETE_REQUEST",
  "DELETE_JOB_TEMPLETE_SUCCESS",
  "DELETE_JOB_TEMPLETE_FAIL"
])
